import { AuthenticationProvider }  from "meportal/AuthenticationProvider";
import { EventTypeProvider } from "../../providers/EventTypeProvider";
import AuthorizedDashboard  from "./Dashboard";
import { Provider } from "react-redux";
import { store, persistor } from "../../store/store";
import { PersistGate } from 'redux-persist/integration/react'
import React, {useState} from "react";
import { ConversationClientProvider } from "meconversation/ConversationClientProvider";
import { ToastProvider } from "../../providers/ToastProvider";

function OpenEvents() {

    return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider>
          <AuthenticationProvider>
            <ConversationClientProvider>
              <EventTypeProvider eventTypeName="">
                <AuthorizedDashboard /> 
              </EventTypeProvider>
            </ConversationClientProvider>
          </AuthenticationProvider>
        </ToastProvider>
      </PersistGate>
    </Provider>
  );
}

export default OpenEvents
